(function () {
  'use strict';

  if (window.__pakhorWishlistLoaded) return;
  window.__pakhorWishlistLoaded = true;

  var STORAGE_KEY = 'pakhor_wishlist';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function formatMoney(cents) {
    if (window.Pakhor && typeof window.Pakhor.formatMoney === 'function') {
      return window.Pakhor.formatMoney(cents);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (Number(cents) / 100).toFixed(2);
  }

  function readList() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      return list.filter(function (h) {
        return typeof h === 'string' && h.trim();
      });
    } catch (e) {
      return [];
    }
  }

  function writeList(handles) {
    var unique = [];
    handles.forEach(function (h) {
      if (unique.indexOf(h) === -1) unique.push(h);
    });
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles: unique } }));
    return unique;
  }

  function isWishlisted(handle) {
    return readList().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    if (!handle) return readList();
    var list = readList();
    var idx = list.indexOf(handle);
    if (idx === -1) list.push(handle);
    else list.splice(idx, 1);
    return writeList(list);
  }

  function remove(handle) {
    return writeList(readList().filter(function (h) {
      return h !== handle;
    }));
  }

  function syncToggleButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-toggle');
      var active = isWishlisted(handle);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.toggleAttribute('data-wishlisted', active);
      btn.textContent = active ? '♥' : '♡';
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function fetchProduct(handle) {
    return fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Not found');
        return res.json();
      });
  }

  function firstAvailableVariant(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  function renderCard(product) {
    var variant = firstAvailableVariant(product);
    var image = product.featured_image || (product.images && product.images[0]);
    var imageSrc = image || '';
    var priceHtml = formatMoney(product.price);
    if (product.compare_at_price && product.compare_at_price > product.price) {
      priceHtml =
        formatMoney(product.price) +
        ' <s style="opacity:0.55;font-weight:400;margin-left:6px;">' +
        formatMoney(product.compare_at_price) +
        '</s>';
    }

    var viewUrl = root() + 'products/' + product.handle;
    var addBtn = '';
    if (variant && variant.available) {
      addBtn =
        '<button type="button" class="btn btn-primary" data-card-add-to-cart data-variant-id="' +
        variant.id +
        '">Add to cart</button>';
    } else {
      addBtn = '<a class="btn btn-secondary" href="' + viewUrl + '">View product</a>';
    }

    return (
      '<article class="pk-wishlist__card" data-wishlist-item="' +
      product.handle +
      '">' +
      '<div class="pk-wishlist__media">' +
      (imageSrc
        ? '<a href="' + viewUrl + '" tabindex="-1" aria-hidden="true"><img src="' + imageSrc + '" alt="" loading="lazy"></a>'
        : '') +
      '<button type="button" class="pk-wishlist__remove" data-wishlist-remove="' +
      product.handle +
      '" aria-label="Remove from wishlist">×</button>' +
      '</div>' +
      '<div class="pk-wishlist__body">' +
      (product.type ? '<p class="pk-wishlist__meta">' + escapeHtml(product.type) + '</p>' : '') +
      '<a class="pk-wishlist__title" href="' + viewUrl + '">' + escapeHtml(product.title) + '</a>' +
      '<p class="pk-wishlist__price">' + priceHtml + '</p>' +
      '<div class="pk-wishlist__actions">' +
      addBtn +
      '<a class="btn btn-secondary" href="' + viewUrl + '">View</a>' +
      '</div>' +
      '</div>' +
      '</article>'
    );
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderWishlistPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;

    var grid = page.querySelector('[data-wishlist-grid]');
    var empty = page.querySelector('[data-wishlist-empty]');
    if (!grid || !empty) return;

    var handles = readList();
    if (!handles.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = '<p class="body-sm" style="grid-column:1/-1;text-align:center;color:var(--color-muted);">Loading your wishlist…</p>';

    Promise.all(
      handles.map(function (handle) {
        return fetchProduct(handle).catch(function () {
          return null;
        });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      var stale = handles.filter(function (handle, i) {
        return !products[i];
      });
      if (stale.length) writeList(handles.filter(function (h) {
        return stale.indexOf(h) === -1;
      }));

      if (!valid.length) {
        grid.innerHTML = '';
        grid.hidden = true;
        empty.hidden = false;
        return;
      }

      grid.innerHTML = valid.map(renderCard).join('');
    });
  }

  function onDocumentClick(e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      toggle(toggleBtn.getAttribute('data-wishlist-toggle'));
      syncToggleButtons();
      return;
    }

    var removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      remove(removeBtn.getAttribute('data-wishlist-remove'));
      renderWishlistPage();
      syncToggleButtons();
    }
  }

  function init() {
    syncToggleButtons();
    renderWishlistPage();
  }

  document.addEventListener('click', onDocumentClick, false);
  document.addEventListener('wishlist:updated', renderWishlistPage);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.PakhorWishlist = {
    list: readList,
    toggle: toggle,
    remove: remove,
    isWishlisted: isWishlisted,
  };
})();
